import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

export const EmailCapture = ({ source, dark = false, invertButton = false, testid }) => {
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            await api.post("/newsletter", { email, first_name: firstName || null, source });
            toast.success("YOU'RE ON THE LIST.", {
                description: "New flavors. New drops. Good times — coming your way.",
            });
            setEmail("");
            setFirstName("");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    const inputCls = `min-w-0 rounded-full px-6 py-4 text-sm font-medium outline-none focus:ring-2 focus:ring-pink ${
        dark
            ? "bg-zinc-900 text-white placeholder:text-zinc-500 border border-zinc-800"
            : "bg-white text-ink placeholder:text-zinc-400 border border-zinc-300"
    }`;

    return (
        <form onSubmit={submit} className="flex flex-col sm:flex-row w-full max-w-xl gap-3" data-testid={`${testid}-form`}>
            <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="First name (optional)"
                data-testid={`${testid}-name-input`}
                className={`${inputCls} sm:w-44`}
            />
            <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                data-testid={`${testid}-email-input`}
                className={`${inputCls} flex-1`}
            />
            <button
                type="submit"
                disabled={loading}
                data-testid={`${testid}-submit-button`}
                className={`rounded-full font-oswald uppercase tracking-widest text-sm px-8 py-4 flex items-center justify-center gap-2 transition-colors duration-300 active:scale-95 ${
                    invertButton
                        ? "bg-ink text-white hover:bg-white hover:text-ink"
                        : "bg-pink text-ink hover:bg-pink-dark hover:text-white"
                }`}
            >
                {loading ? "..." : "JOIN"} <ArrowRight size={16} />
            </button>
        </form>
    );
};
